/** Shared cell display helpers for LMS index table + peek. */

const money = new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' })

export function displayCell (row, col) {
  if (!row || !col) return ''
  const raw = row[col.key]
  if (raw == null || raw === '') return '—'

  switch (col.type) {
    case 'date':
      if (typeof raw === 'object' && raw.display != null) return plainText(raw.display) || '—'
      return plainText(raw)
    case 'money':
      return Number.isFinite(Number(raw)) ? money.format(Number(raw)) : plainText(raw)
    case 'checkbox':
      return raw ? 'Yes' : 'No'
    case 'link':
      if (typeof raw === 'object') return raw.if ? 'Open' : '—'
      return plainText(raw)
    case 'file':
      return fileLabel(raw)
    case 'html':
      return String(raw).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim() || '—'
    case 'audit':
      if (typeof raw === 'object') return formatAudit(raw)
      return plainText(raw)
    case 'html':
      // Callers that need markup should use v-html; displayCell always returns text.
      return plainText(raw) || '—'
    default:
      if (typeof raw === 'object') {
        if (raw.kind === 'file') return fileLabel(raw)
        if (raw.display != null) return plainText(raw.display) || '—'
        return JSON.stringify(raw)
      }
      return plainText(raw)
  }
}

/** Strip accidental HTML (e.g. classic link_to SafeBuffers) for safe text display. */
export function plainText (value) {
  if (value == null) return ''
  const text = String(value)
  if (!text.includes('<')) return text
  if (typeof document !== 'undefined') {
    const el = document.createElement('div')
    el.innerHTML = text
    return (el.textContent || el.innerText || '').replace(/\s+/g, ' ').trim()
  }
  return text.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
}

function fileLabel (raw) {
  if (raw == null || raw === '') return '—'
  if (typeof raw === 'object') {
    if (!raw.url) return '—'
    return raw.viewLabel || 'View File'
  }
  return plainText(raw)
}

function formatAudit (obj, depth = 0) {
  if (obj == null) return ''
  if (typeof obj !== 'object') return String(obj)
  return Object.entries(obj)
    .map(([k, v]) => {
      if (typeof v === 'object' && v !== null) return `${k}: ${formatAudit(v, depth + 1)}`
      return `${k}: ${v}`
    })
    .join(depth === 0 ? ' · ' : ', ')
}

export function cellSortValue (row, col) {
  const raw = row?.[col.key]
  if (col.type === 'date' && raw && typeof raw === 'object') return raw.timestamp || 0
  return raw
}
